import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import StatisticsSection from './components/StatisticsSection';
import ExpertiseSection from './components/ExpertiseSection';
import TeamSection from './components/TeamSection';
import CertificationsSection from './components/CertificationsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { useLanguage } from '../../contexts/LanguageContext';

const AboutUs = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-[60px]">
        <HeroSection language={language} />
        <MissionSection language={language} />
        <StatisticsSection language={language} />
        <ExpertiseSection language={language} />
        <TeamSection language={language} />
        <CertificationsSection language={language} />
        <CTASection language={language} />
      </main>
      <Footer language={language} />
    </div>
  );
};

export default AboutUs;